// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"6bc601ee","138":"f529fc65","143":"b48ee3f1","357":"924708ee","620":"6c643e49","997":"100b02de"}[chunkId] + ".chunk.js";
};